var filter = "https://shopfront-cdn.tekoapis.com/static/fc1421026697d60f.svg";

export { filter as default };
